import { render, staticRenderFns } from "./wantLevel.vue?vue&type=template&id=a9935f1c&scoped=true"
import script from "./wantLevel.vue?vue&type=script&lang=js"
export * from "./wantLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9935f1c",
  null
  
)

export default component.exports